import * as React from "react";
import { container, image, subTitle, title } from "./PageTeaser.module.scss";
import { GatsbyImage } from "gatsby-plugin-image";
import { Col, Row } from "react-bootstrap";
import { IPageTeaserProps } from "./PageTeaserProps";
import { Link } from "gatsby";

export const StyledRow: React.FC<any> = (props) => {
  return (
    <Row
      noGutters
      className={`position-relative mt-4 mt-sm-5 mb-4 mb-sm-5 ${container}`}
      {...props}
    >
      {props.children}
    </Row>
  );
};

export const Subtitle: React.FC<any> = (props) => {
  return (
    <div id={props.id} className={subTitle}>
      {props.children}
    </div>
  );
};

export const Title: React.FC<any> = (props) => {
  return props.titelNodeType ? (
    <h2 id={"page-teaser-title"} className={title}>
      {props.field_title}
    </h2>
  ) : (
    <h3 id={"page-teaser-title"} className={title}>
      {props.field_title}
    </h3>
  );
};

export const ImageContainer: React.FC<any> = (props) => {
  return (
    <GatsbyImage
      alt={props.alt}
      image={props.image}
      className={`col-lg-6 ${image} ${props.imagePosition}`}
    />
  );
};

export const ContentContainer: React.FC<IPageTeaserProps> = (props) => {
  const link = props.field_link;
  return (
    <Col
      id={"page-teaser"}
      className={`content-wrapper ${props.class} d-flex justify-content-center flex-column`}
    >
      <div className="p-3 p-lg-5 text-center">
        {props.field_subtitle && (
          <Subtitle id={"page-teaser-subtitle"} className="subheader">
            {props.field_subtitle}
          </Subtitle>
        )}
        <Title className="title" {...props} />
        <p
          id={"page-teaser-description"}
          dangerouslySetInnerHTML={{ __html: props.field_description }}
          className="description"
        />
        {link !== null && (
          <div>
            {link.url.includes("http") || link.url.includes("com") ? (
              <a
                href={link.url}
                target="_blank"
                className="teaser-link"
                aria-label={`${link.title} for ${props.field_subtitle}`}
                style={
                  props.backgroundColor
                    ? { borderBottomColor: props.backgroundColor }
                    : {}
                }
                id="page-teaser-external-link"
                rel="noreferrer"
              >
                {link.title}
              </a>
            ) : (
              <Link
                to={link.url}
                className="teaser-link"
                aria-label={`${link.title} for ${props.field_subtitle}`}
                style={
                  props.backgroundColor
                    ? { borderBottomColor: props.backgroundColor }
                    : {}
                }
                id="page-teaser-internal-link"
              >
                {link.title}
              </Link>
            )}
          </div>
        )}
      </div>
    </Col>
  );
};
